class RecommendationsCarousel extends HTMLElement {
  constructor() {
    super();

    this.productId = this.dataset.productId;
    this.sectionId = this.dataset.sectionId;
    this.limit = this.dataset.limit || 8;

    this.wrapperSelector = "[data-recommendations-wrapper]";
    this.swiperInstance = null;
  }

  connectedCallback() {

    if (!this.productId || !this.sectionId) {
      console.warn(
        "RecommendationsCarousel: missing data-product-id or data-section-id"
      );
      return;
    }

    this.fetchRecommendations();
  }

  getRecommendationsUrl() {
    const base = window.Shopify?.routes?.root || "/";
    const url = new URL(`${base}recommendations/products`, window.location.origin);

    url.searchParams.set("section_id", this.sectionId);
    url.searchParams.set("product_id", this.productId);
    url.searchParams.set("limit", this.limit);

    return url.toString();
  }

  async fetchRecommendations() {
    try {
      const url = this.getRecommendationsUrl();
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Recommendations fetch failed: ${response.status}`);
      }

      const html = await response.text();
      this.replaceContent(html);
      this.initSwiper();
    } catch (error) {
      console.error("RecommendationsCarousel error:", error);
    }
  }

  replaceContent(sectionHtml) {
    // Parse returned HTML as a document
    const parser = new DOMParser();
    const doc = parser.parseFromString(sectionHtml, "text/html");

    // Find the SAME wrapper inside the returned section
    const incomingWrapper = doc.querySelector(this.wrapperSelector);
    const currentWrapper = this.querySelector(this.wrapperSelector);

    if (!incomingWrapper || !currentWrapper) {
      console.warn("RecommendationsCarousel: wrapper not found");
      return;
    }

    // Replace existing slides with fetched ones
    currentWrapper.innerHTML = incomingWrapper.innerHTML;
  }

  initSwiper() {
    // No-op if there are no slides
    const slideCount = this.querySelectorAll(".swiper-slide").length;
    if (!slideCount) {
      return;
    }

    // Init your slider here – assuming Swiper is already loaded globally
    try {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
      }

      const swiperEl = this.querySelector(".js-recs-swiper");

      // Replace with your actual Swiper config
      this.swiperInstance = new Swiper(swiperEl, {
        slidesPerView: 3,
        spaceBetween: 24,
        loop: true,
        breakpoints: {
          0: { slidesPerView: 1.2 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        },
      });
  d    } catch (error) {
      console.error("RecommendationsCarousel: error initializing Swiper", error);
    }
  }
}

customElements.define("recommendations-carousel", RecommendationsCarousel);
